import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TipoContatoEnum } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { ColumnOrder } from '@core/table/order';
import { OutrosContatosFormComponent } from '@modules/contato/outros-contatos-form/outros-contatos-form.component';
import { addFormControls } from '@shared/util/util';
import { AppSignalDataService } from 'src/app/app-signal-data.service';

@Component({
  selector: 'app-outros-contatos-vinculo-list',
  templateUrl: './outros-contatos-vinculo-list.component.html',
  styleUrls: ['./outros-contatos-vinculo-list.component.scss']
})
export class OutrosContatosVinculoListComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() data!: any;
  @Input() nomePagina!: NomePaginaEnum;
  @Input() paginaEntidade: boolean = false;

  @Input() form!: FormGroup;
  @Input() entidade: any;
  @Input() contato: any;
  @Input() dataSet: any[]=[];
  @Output() dadosOutrosContatosEmit = new EventEmitter<any>();
  @ViewChild(OutrosContatosFormComponent) outrosContatosFormComponent!: OutrosContatosFormComponent;

  @Input() dadosIdSelecionado!: any;
  @Input() entidadeIdSelecionado: any;
  @Input() pessoaIdSelecionado: any;

  columOrder: ColumnOrder | undefined;
  tipoContatoSelecionado: any;
  tipoContatoEnum = TipoContatoEnum;

  constructor(
    public route: ActivatedRoute,
    private appSignalDataService: AppSignalDataService,
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }

  ngAfterViewInit(): void {

    // this.outrosContatosFormComponent?.dadosOutrosContatosEmit.subscribe((res: any) => {
    //   res.flagPrincipal = false;
    //   const index = this.dataSet.findIndex((item: any) => item.id === res.id);
    //   if (index !== -1) {
    //     this.dataSet[index] = res;
    //     this.enviarOutrosContatos();
    //   } else {
    //     this.dataSet.push(res);
    //     this.enviarOutrosContatos();
    //   }
    // });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const nomeObs = this.nomePagina + 'Contatos';

    if(this.nomePagina === NomePaginaEnum.ENTIDADE) {
      this.paginaEntidade = true;
    }

    if (this.data && this.data[nomeObs]) {
      const contatos = this.data[nomeObs];
      this.dataSet = contatos.filter((item: any) => !item.flagPrincipal);
      this.enviarOutrosContatos();
    }
  }

  ngOnInit(): void {
    this.construirForm();
  }

  construirForm() {
    const nomeObs = this.nomePagina + 'OutrosContatos';
    addFormControls(this.form, {
      [nomeObs]: [],
    });
  }

  editarItem(obj: any) {
    this.contato = obj;
  }

  removerContato(obj?: any): void {
    const index: number = this.dataSet.indexOf(obj);
    if (index !== -1) {
      this.dataSet.splice(index, 1);
      this.enviarOutrosContatos();
    }
  }

  enviarOutrosContatos() {
    this.form.get('vinculoOutrosContatos')?.setValue(this.dataSet);
  }

  sort(event: any) {
    const column = event.sort.find((x: any) => x.value);
    if (column) {
      const sortKey = column.key;
      const sortOrder = column.value === 'ascend' ? 1 : -1;

      this.dataSet = [...this.dataSet].sort((a, b) => {
        const valueA = this.getNestedValue(a, sortKey);
        const valueB = this.getNestedValue(b, sortKey);

        if (valueA < valueB) {
          return -1 * sortOrder;
        }
        if (valueA > valueB) {
          return 1 * sortOrder;
        }
        return 0;
      });
    } else {
      this.dataSet = [...this.dataSet];
    }
  }

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o ? o[k] : null), obj);
  }


  receberTipoContatoIdEmit(event: any) {
    if(event) {
      this.tipoContatoSelecionado = event;
    }
  }

  receberDadosOutrosContatosEmit(res: any) {
    res.flagPrincipal = false;
    const index = this.dataSet.findIndex((item: any) => item.id === res.id);
    if (index !== -1) {
      this.dataSet[index] = res;
      this.enviarOutrosContatos();
    } else {
      this.dataSet.push(res);
      this.enviarOutrosContatos();
    }
  }

}
